'use client'
import { FunctionComponent, ReactElement, useContext } from 'react'
import Accordion from '../Accordion/Accordion'
import { ConfigContext } from '../../context/ConfigContext'

type productAccordionType = {
  itemsDefault: {
    title: string | ReactElement
    content: ReactElement
  }[]
  itemsEcommerce: {
    title: string | ReactElement
    content: ReactElement
  }[]
  displayedProduct: Product
}
const ProductAccordion: FunctionComponent<productAccordionType> = ({
  itemsDefault,
  itemsEcommerce,
  displayedProduct,
}) => {
  const { isEcommerce } = useContext(ConfigContext)

  return (
    <Accordion
      items={isEcommerce() ? itemsEcommerce : itemsDefault}
      product={displayedProduct}
      defaultIndex={0}
    />
  )
}

export default ProductAccordion
